import { formatCurrency } from '../../../../common/SharedFunctions';
import { EditBudgetButton } from './EditBudgetButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { ProblemPropertyIndicator } from './ProblemPropertyIndicator';

export const FundedBudgetDrawPanel = ({ property, styles, validateSubmission, onProblemPropertyChange }) => {
    return (
        <div style={styles.displayFlex}>
            <span style={{ marginRight: 5 }}>Funded {formatCurrency(property.drawFundedTotal, 0)}</span>
            <span style={{ marginLeft: 60, marginRight: 5, color: 'green' }}>
                <FontAwesomeIcon icon={faCheck} />
            </span>
            <p>Budget is Setup</p>
            <EditBudgetButton
                property={property}
                styles={styles}
                validateSubmission={validateSubmission}
            />
            <ProblemPropertyIndicator
                problemProperty={property.isProblemProperty}
                onChange={onProblemPropertyChange}
            />
        </div>
    );
};
